import { sortBy } from 'lodash-es';

import {
  TripEventRead,
  useTripsEventsListQuery,
} from 'src/common/external/bambi-api/bambiApi';

import { editableStatusUpdateEvents } from './eventTypes';

export function useLatestTripEventsOfType(tripId: string) {
  return useTripsEventsListQuery(
    {
      id: tripId,
    },
    {
      selectFromResult: (result) => {
        const latestEvents = getLatestEvents(result.data?.results || []);
        return {
          ...result,
          events: latestEvents,
        };
      },
    }
  );
}

function getLatestEvents(events: TripEventRead[]) {
  const editableEvents = events.filter((event) =>
    editableStatusUpdateEvents.includes(event.event_type)
  );
  const sortedByCreatedAt = sortBy(editableEvents, 'created_at');

  const onlyLatestEventsOfEachType: Record<
    TripEventRead['event_type'],
    TripEventRead
  > = {} as Record<TripEventRead['event_type'], TripEventRead>;
  sortedByCreatedAt.forEach((event) => {
    onlyLatestEventsOfEachType[event.event_type] = event;
  });
  const latestEvents = Object.values(onlyLatestEventsOfEachType);

  return sortBy(latestEvents, 'occurred_at');
}
